<template>
  <!-- eslint-disable max-len -->
  <main class="bg-white u-container">
    <p class="mb-4">
      Mail addressed to an addressee at commercial mail receiving agency (CMRA) is not forwarded through the USPS. The CMRA customer may make special arrangements for the CMRA operator to re-mail the mail with payment of new postage. A CMRA must accept and re-mail mail to former customers for at least 6 months after termination of the agency relationship. After the 6-month period, the CMRA may refuse mail addressed to a former customer. The Application for Delivery of Mail through Agent (PS Form 1583) requires an addressee and agent to comply with all applicable postal rules and regulations relative to delivery of mail through an agent. For more information on mail forwarding regulations, contact your local Postmaster.
    </p>
    <button
      ref="exit"
      class="c-btn--secondary mr-5 mb-5 sm:mb-0 m:mb-0 lg:mb-0 xl:mg-0"
      @click="reboot"
    >
      Exit
    </button>
    <router-link
      ref="editAddress"
      :to="editRoute"
      class="c-btn"
    >
      Re-enter Addresses
    </router-link>
  </main>
</template>

<script>
import { isDesktop } from '../utils/deviceType';
import pageView from '../mixins/pageView';

export default {
  name: 'ErrorCMRA',
  mixins: [pageView],
  computed: {
    editRoute() {
      return { name: !isDesktop() ? 'move-combined' : 'disclaimer' };
    },
  },
  mounted() {
    this.pageView();
  },
  methods: {
    reboot() {
      this.$deleteSession();
      this.$coa.reset();
      this.$router.replace({ name: 'disclaimer' });
    },
  },
};
</script>
